import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import config from '../../config.js';

const DataSourceActiveButton = ({ savedsource }) => {
    const [isActive, setIsActive] = useState(savedsource.status);
    const [loading, setLoading] = useState(false);

    const toggleActive = async () => {
        setLoading(true);
        try {
            const config_home = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            };

            const data = {
                fulfillment_source_data: savedsource,
                status: !isActive
            };

            const response = await axios.put(`${config.serviceUrl}/fulfillment-source/status_update`, data, config_home);

            if (response.data.status === 200) {
                const updatedStatus = response.data.fulfillment_source_status;
                setIsActive(updatedStatus);
            } else {
                console.error('Failed to update status');
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    const getStatusLabel = () => {
        if (loading) {
            return 'Updating...';
        }
        return isActive ? 'Active' : 'Inactive';
    };

    return (
        <div className="form-check form-switch">
            <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id={`toggle-${savedsource.id}`}
                checked={isActive}
                onChange={toggleActive}
                disabled={loading}
            />
            <label className="form-check-label" htmlFor={`toggle-${savedsource.id}`}>
                {getStatusLabel()}
            </label>
        </div>
    );
};

// Define PropTypes for DataSourceActiveButton
DataSourceActiveButton.propTypes = {
    savedsource: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        status: PropTypes.bool.isRequired
    }).isRequired
};

export default DataSourceActiveButton;